import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-59c2889c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "p-text-left"
}
const _hoisted_2 = { class: "p-p-3 bg-color-secondary p-d-flex p-jc-between" }
const _hoisted_3 = { class: "p-text-bold" }
const _hoisted_4 = { class: "p-mx-3 p-p-2 p-mb-2" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-my-1 p-mt-2 p-mb-2 p-text-bold" }, "รายการสินค้า", -1))
const _hoisted_6 = {
  key: 0,
  class: "box-no-product shadow bg-color-secondary rounded p-d-flex p-my-2 p-jc-center"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-m-auto" }, "ไม่พบรายการสินค้าในตะกร้า", -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "p-p-3 shadow bg-color-secondary rounded p-d-flex p-my-2" }
const _hoisted_10 = {
  key: 0,
  class: "p-my-auto"
}
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "p-ml-2 w-100" }
const _hoisted_13 = { class: "p-d-flex w-100" }
const _hoisted_14 = { class: "line-clamp" }
const _hoisted_15 = { class: "p-ml-auto" }
const _hoisted_16 = { class: "f-size-14 text-gray-1" }
const _hoisted_17 = { class: "p-d-flex" }
const _hoisted_18 = { class: "f-size-14 text-gray-1" }
const _hoisted_19 = {
  key: 0,
  class: "p-ml-auto f-size-14"
}
const _hoisted_20 = { class: "text-gray-1" }
const _hoisted_21 = { class: "p-ml-2 text-dark" }
const _hoisted_22 = {
  key: 1,
  class: "p-ml-auto f-size-14"
}
const _hoisted_23 = { class: "p-mt-3 p-d-flex p-jc-between" }
const _hoisted_24 = { class: "p-inputgroup" }
const _hoisted_25 = { class: "p-ml-2" }
const _hoisted_26 = {
  key: 2,
  class: "p-d-flex p-mb-2 p-mt-3"
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-text-bold" }, "รายการของแถม", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-ml-auto" }, "-", -1))
const _hoisted_29 = [
  _hoisted_27,
  _hoisted_28
]
const _hoisted_30 = {
  key: 3,
  class: "p-mb-2 p-mt-3"
}
const _hoisted_31 = { class: "p-mt-4" }
const _hoisted_32 = { class: "p-d-flex" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "ราคารวม", -1))
const _hoisted_34 = { class: "p-ml-auto" }
const _hoisted_35 = {
  key: 0,
  class: "p-d-flex"
}
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "ส่วนลด", -1))
const _hoisted_37 = { class: "p-ml-auto" }
const _hoisted_38 = { class: "p-d-flex" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "ราคาสุทธิ", -1))
const _hoisted_40 = { class: "p-ml-auto" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_TransactionFreeProduct = _resolveComponent("TransactionFreeProduct")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.transaction)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("span", _hoisted_3, "รายการสั่งซื้อ (ราคาสุทธิ " + _toDisplayString(_ctx.transaction.grandTotal) + ")", 1)
          ]),
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            (_ctx.transaction.products.length == 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8))
              : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.transaction.products, (product, pindex) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: 'product_' + pindex
                  }, [
                    _createElementVNode("div", _hoisted_9, [
                      (product.imageUrl)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                            _createElementVNode("img", {
                              src: product.imageUrl,
                              class: "product-image"
                            }, null, 8, _hoisted_11)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("div", _hoisted_13, [
                          _createElementVNode("div", _hoisted_14, _toDisplayString(product.name), 1),
                          _createElementVNode("div", _hoisted_15, _toDisplayString(product.quantity), 1)
                        ]),
                        _createElementVNode("div", _hoisted_16, _toDisplayString(product.barcode), 1),
                        _createElementVNode("div", _hoisted_17, [
                          _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.$filters.formatNumber(product.price)) + " x " + _toDisplayString(product.quantity), 1),
                          (product.discountStikePrice !== 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                _createElementVNode("del", _hoisted_20, _toDisplayString(_ctx.$filters.formatNumber(product.total)), 1),
                                _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.$filters.formatNumber(product.stikePrice)), 1)
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString(_ctx.$filters.formatNumber(product.total)), 1))
                        ]),
                        _createElementVNode("div", _hoisted_23, [
                          _createElementVNode("div", _hoisted_24, [
                            _createVNode(_component_Button, {
                              icon: "pi pi-plus",
                              class: "p-button-success",
                              style: _normalizeStyle({
                        'background-color': _ctx.backgroundColor,
                        'border-color': _ctx.backgroundColor,
                      }),
                              onClick: ($event: any) => (_ctx.onAddQuantity(pindex))
                            }, null, 8, ["style", "onClick"]),
                            _createVNode(_component_InputText, {
                              placeholder: "quantity",
                              class: "input-quantity",
                              disabled: true,
                              modelValue: product.quantity,
                              "onUpdate:modelValue": ($event: any) => ((product.quantity) = $event)
                            }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                            _createVNode(_component_Button, {
                              icon: "pi pi-minus",
                              class: "p-button-danger",
                              style: _normalizeStyle({
                        'background-color': _ctx.backgroundColor,
                        'border-color': _ctx.backgroundColor,
                      }),
                              onClick: ($event: any) => (_ctx.onRemoveQuantity(pindex))
                            }, null, 8, ["style", "onClick"])
                          ]),
                          _createElementVNode("div", _hoisted_25, [
                            _createVNode(_component_Button, {
                              icon: "pi pi-trash",
                              class: "bg-black",
                              onClick: ($event: any) => (_ctx.onRemoveAllProduct(pindex))
                            }, null, 8, ["onClick"])
                          ])
                        ])
                      ])
                    ])
                  ]))
                }), 128)),
            (_ctx.transaction.freeProducts.length == 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_26, _hoisted_29))
              : _createCommentVNode("", true),
            (_ctx.transaction.freeProducts.length !== 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                  _createElementVNode("div", null, [
                    _createVNode(_component_TransactionFreeProduct, {
                      freeProducts: _ctx.transaction.freeProducts,
                      onOnSubmitFreeProduct: _ctx.onSubmitFreeProduct,
                      ref: "freeProductPanel"
                    }, null, 8, ["freeProducts", "onOnSubmitFreeProduct"])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("div", _hoisted_32, [
                _hoisted_33,
                _createElementVNode("div", _hoisted_34, _toDisplayString(_ctx.$filters.formatNumber(_ctx.transaction.total)), 1)
              ]),
              (_ctx.transaction.discount > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                    _hoisted_36,
                    _createElementVNode("div", _hoisted_37, _toDisplayString(_ctx.$filters.formatNumber(_ctx.transaction.discount)), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_38, [
                _hoisted_39,
                _createElementVNode("div", _hoisted_40, _toDisplayString(_ctx.$filters.formatNumber(_ctx.transaction.grandTotal)), 1)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}